import type { FaireProductEntity } from "../../entity_types/product";

export const p_bdm4n5vsfv: FaireProductEntity = {
  token: "p_bdm4n5vsfv",
  type: "product",
  name: "Spice and Wolf, Vol. 15",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2c3f89ab1f6387690be99624b4c6d3dfd4a59ebcae438c0457542ab708e782a7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1a896e8f032476f242ac4764eed048b9ee3f66413d84fafd35a05e55dbd0c8f.jpeg"
  ],
  priceDollars: 6.5,
  description: "Parental Advisory: Explicit Content Warning\n\nThe Debau Company is headed to a point of no return. The radicals within the company have made their move and deposed the conservative faction, all the while steering the northlands closer to the brink of open battle. A certain wolf rushes South as fast as her paws can carry her, but can Lawrence and the Myuri Mercenary Company hold back the flames of war long enough for a chance at lasting peace?",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:36.186Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
